import WorkCookies from "@/services/cookie_services/WorkCookies";

var TokenAuthenticationHandler = (function () {
    var initialize = function ({ xAuthToken }) {
        return WorkCookies.setAuthToken(xAuthToken);
    }

    var terminate = function () {
        return WorkCookies.removeAuthToken();
    }

    return {
        initialize: initialize,
        terminate: terminate
    }
}());

export default TokenAuthenticationHandler;
